import { useCallback, useState } from "react";

export const useLocalStorage = () => {
  const [value, setValue] = useState<string | null>(null);

  const setItem = useCallback((key: string, next: string) => {
    localStorage.setItem(key, next);
    setValue(next);
  }, []);

  // Read-only on purpose: a getter that also sets state re-renders every caller,
  // and an effect depending on it would then re-fire forever.
  const getItem = useCallback((key: string) => localStorage.getItem(key), []);

  const clearAll = useCallback(() => {
    localStorage.clear();
  }, []);

  const removeItem = useCallback((key: string) => {
    localStorage.removeItem(key);
    setValue(null);
  }, []);

  return { value, setItem, getItem, removeItem, clearAll };
};
